import styled from 'styled-components';

import { Menu } from 'antd';
import { Pane, Table, DatePicker } from 'components/common';
import { colours } from 'utils/theme';

const statusColorMapping = {
  //Used for Tradeshow status
  upcoming: colours.blue,
  ongoing: colours.green,
  completed: colours.grey,
  cancelled: colours.red,
  postponed: colours.darkOrange,
  tbc: colours.orange,
  //Used for Platform status
  inPlatform: colours.green,
  pending: colours.darkOrange,
};

export const Container = styled(Pane)`
  margin-top: ${p => p.theme.gutter};
`;

export const StyledTable = styled(Table)`
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  margin-top: 10px;
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;

  ${p => p.theme.breakpoint.tablet} {
    gap: 3px;
    margin-top: 3px;
  }
`;

export const FilterButtonGroup = styled.div`
  display: flex;
  width: 200px;
  gap: 10px;
  margin-left: 20px;

  ${p => p.theme.breakpoint.tablet} {
    gap: 3px;
  }
`;

export const FilterActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 20px;

  ${p => p.theme.breakpoint.tablet} {
    gap: 3px;
  }
`;

export const FilterSection = styled(FilterContainer)`
  margin-top: 0px;
  justify-content: flex-start;
  align-items: center;
  ${({ show }) => show === false && 'display: none;'}
`;

export const Filters = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  ${p => p.theme.breakpoint.tablet} {
    gap: 3px;
  }
`;

export const Status = styled.div`
  display: flex;
  align-items: center !important;
  text-transform: uppercase;
  font-size: 11px;
  color: ${p => statusColorMapping[p.status]};
  font-weight: 500;
`;

export const InlineFlexGroup = styled.div`
  display: inline-flex;
  align-items: center;
  lineheight: '1';
  gap: 5px;
`;

export const VirtualLocationPip = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  background-color: ${colours.lightGrey};
  padding: 2px 10px;
`;

export const Content = styled.div`
  > * {
    margin-bottom: 10px;
  }
`;

export const Label = styled.div`
  font-weight: 500;
  margin-right: 5px;
`;

export const UploadMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > svg {
    margin-bottom: 15px;
  }
`;

export const CustomDatePicker = styled(DatePicker)`
  width: 400px;
`;

export const ScrollableMenu = styled(Menu)`
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
  }
  ::-webkit-scrollbar-track {
    background: white;
  }

  .ant-menu-item-selected {
    font-weight: bold;
    background-color: #ecf6fe !important;
    color: black;
  }

  .ant-menu-vertical > .ant-menu-item,
  .ant-menu-vertical-left > .ant-menu-item,
  .ant-menu-vertical-right > .ant-menu-item,
  .ant-menu-inline > .ant-menu-item,
  .ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    height: 30px;
    line-height: 30px;
  }

  ant-menu-submenu,
  ant-menu-submenu-vertical,
  ant-menu-submenu-selected {
    font-weight: bold;
    background-color: #ecf6fe !important;
    color: black;
  }

  .ant-menu-submenu {
    .ant-menu {
      max-height: 300px;
      max-width: 100px;

      ::-webkit-scrollbar {
        width: 8px;
      }
      ::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 4px;
      }
      ::-webkit-scrollbar-track {
        background: white;
      }
    }
  }
`;
